import { Typography } from '@material-ui/core'
import useStyles from './styles'

export type PostViewProps = APIResponse.DME.Post

export default function PostView({
  body,
  description,
  featuredImage,
  title,
}: PostViewProps) {
  const classes = useStyles()

  return (
    <article>
      <Typography variant="h4" component="h1">
        {title}
      </Typography>
      <Typography
        color="textSecondary"
        component="h2"
        gutterBottom
        variant="subtitle1"
      >
        {description}
      </Typography>
      <img
        className={classes.featuredImage}
        src={featuredImage.url}
        alt={featuredImage.alt}
      />
      {body.map((cont) => (
        <div
          className={classes.postSection}
          dangerouslySetInnerHTML={{ __html: cont.content }}
          key={cont.id}
        />
      ))}
    </article>
  )
}
